import { createClient } from '@supabase/supabase-js';

// --- AUTO-GENERATED TYPES FROM SUPABASE MCP ---
export type Json =
  | string
  | number
  | boolean
  | null
  | { [key: string]: Json | undefined }
  | Json[];

export type Database = {
  public: {
    Tables: {
      activity_logs: {
        Row: {
          action_type: string;
          details: Json | null;
          id: number;
          project_id: string | null;
          related_entity_id: string | null;
          related_entity_type: string | null;
          timestamp: string;
          user_id: string | null;
        };
        Insert: {
          action_type: string;
          details?: Json | null;
          id?: never;
          project_id?: string | null;
          related_entity_id?: string | null;
          related_entity_type?: string | null;
          timestamp?: string;
          user_id?: string | null;
        };
        Update: {
          action_type?: string;
          details?: Json | null;
          id?: never;
          project_id?: string | null;
          related_entity_id?: string | null;
          related_entity_type?: string | null;
          timestamp?: string;
          user_id?: string | null;
        };
        Relationships: [
          {
            foreignKeyName: "activity_logs_project_id_fkey";
            columns: ["project_id"];
            isOneToOne: false;
            referencedRelation: "projects";
            referencedColumns: ["id"];
          },
          {
            foreignKeyName: "activity_logs_project_id_fkey";
            columns: ["project_id"];
            isOneToOne: false;
            referencedRelation: "projects_with_access";
            referencedColumns: ["id"];
          },
        ];
      },
      installer_partners: {
        Row: {
          id: number;
          company_name: string;
          contact_name: string | null;
          contact_email: string | null;
          contact_phone: string | null;
          is_active: boolean | null;
          created_at: string;
          updated_at: string;
          street: string | null;
          city: string | null;
          state: string | null;
          zip_code: string | null;
          county: string | null;
        };
        Insert: {
          company_name: string;
          contact_name?: string | null;
          contact_email?: string | null;
          contact_phone?: string | null;
          is_active?: boolean | null;
          created_at?: string;
          updated_at?: string;
          street?: string | null;
          city?: string | null;
          state?: string | null;
          zip_code?: string | null;
          county?: string | null;
        };
        Update: {
          company_name?: string;
          contact_name?: string | null;
          contact_email?: string | null;
          contact_phone?: string | null;
          is_active?: boolean | null;
          created_at?: string;
          updated_at?: string;
          street?: string | null;
          city?: string | null;
          state?: string | null;
          zip_code?: string | null;
          county?: string | null;
        };
        Relationships: [];
      },
      // ... (all other tables, views, enums, and types as generated by MCP)
    };
    // ... (Views, Functions, Enums, CompositeTypes as generated by MCP)
  };
};

// --- END AUTO-GENERATED TYPES ---

// Import the supabase client from supabaseClient.ts instead of creating a new one
import { supabase as supabaseClient } from './supabaseClient';

// Export the typed supabase client
export const supabase = supabaseClient as unknown as ReturnType<typeof createClient<Database>>;
